"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Wed Jun 27 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var ProductCategoryChangeProcessConverter_1 = require("./conversions/ProductCategoryChangeProcessConverter");

var ProductCategoryChangeProcessConverterImpl_1 = require("./conversions/ProductCategoryChangeProcessConverterImpl");

var CompetitorProductBindingConverter_1 = require("./conversions/CompetitorProductBindingConverter");

var CompetitorProductBindingConverterImpl_1 = require("./conversions/CompetitorProductBindingConverterImpl");

var CompetitorProductConverter_1 = require("./conversions/CompetitorProductConverter");

var CompetitorProductConverterImpl_1 = require("./conversions/CompetitorProductConverterImpl");

var CompetitorProductFilterConverter_1 = require("./conversions/CompetitorProductFilterConverter");

var CompetitorProductFilterConverterImpl_1 = require("./conversions/CompetitorProductFilterConverterImpl");

var FindWindowProductsDTOConverter_1 = require("./conversions/FindWindowProductsDTOConverter");

var FindWindowProductsDTOConverterImpl_1 = require("./conversions/FindWindowProductsDTOConverterImpl");

var PlacementTypesConverter_1 = require("./conversions/PlacementTypesConverter");

var PlacementTypesConverterImpl_1 = require("./conversions/PlacementTypesConverterImpl");

var PriceArchitectureExportDTOConverter_1 = require("./conversions/PriceArchitectureExportDTOConverter");

var PriceArchitectureExportDTOConverterImpl_1 = require("./conversions/PriceArchitectureExportDTOConverterImpl");

var PriceChangeIndexConverter_1 = require("./conversions/PriceChangeIndexConverter");

var PriceChangeIndexConverterImpl_1 = require("./conversions/PriceChangeIndexConverterImpl");

var PriceWithValidityConverter_1 = require("./conversions/PriceWithValidityConverter");

var PriceWithValidityConverterImpl_1 = require("./conversions/PriceWithValidityConverterImpl");

var PriceWithVatConverter_1 = require("./conversions/PriceWithVatConverter");

var PriceWithVatConverterImpl_1 = require("./conversions/PriceWithVatConverterImpl");

var ProductCategoryConverter_1 = require("./conversions/ProductCategoryConverter");

var ProductCategoryConverterImpl_1 = require("./conversions/ProductCategoryConverterImpl");

var ProductCategoryChangeConverter_1 = require("./conversions/ProductCategoryChangeConverter");

var ProductCategoryChangeConverterImpl_1 = require("./conversions/ProductCategoryChangeConverterImpl");

var ProductConverter_1 = require("./conversions/ProductConverter");

var ProductConverterImpl_1 = require("./conversions/ProductConverterImpl");

var ProductEANConverter_1 = require("./conversions/ProductEANConverter");

var ProductEANConverterImpl_1 = require("./conversions/ProductEANConverterImpl");

var ProductInfoConverter_1 = require("./conversions/ProductInfoConverter");

var ProductInfoConverterImpl_1 = require("./conversions/ProductInfoConverterImpl");

var ProductInfoFilterConverter_1 = require("./conversions/ProductInfoFilterConverter");

var ProductInfoFilterConverterImpl_1 = require("./conversions/ProductInfoFilterConverterImpl");

var ProductNameAndCategoriesConverter_1 = require("./conversions/ProductNameAndCategoriesConverter");

var ProductNameAndCategoriesConverterImpl_1 = require("./conversions/ProductNameAndCategoriesConverterImpl");

var ProductPlacementConverter_1 = require("./conversions/ProductPlacementConverter");

var ProductPlacementConverterImpl_1 = require("./conversions/ProductPlacementConverterImpl");

var ProductPriceConverter_1 = require("./conversions/ProductPriceConverter");

var ProductPriceConverterImpl_1 = require("./conversions/ProductPriceConverterImpl");

var ProductPurchasePriceConverter_1 = require("./conversions/ProductPurchasePriceConverter");

var ProductPurchasePriceConverterImpl_1 = require("./conversions/ProductPurchasePriceConverterImpl");

var ProductSensitivityConverter_1 = require("./conversions/ProductSensitivityConverter");

var ProductSensitivityConverterImpl_1 = require("./conversions/ProductSensitivityConverterImpl");

var ProductSensitivityExportQueueRecordConverter_1 = require("./conversions/ProductSensitivityExportQueueRecordConverter");

var ProductSensitivityExportQueueRecordConverterImpl_1 = require("./conversions/ProductSensitivityExportQueueRecordConverterImpl");

var ProductSiteBindingConverter_1 = require("./conversions/ProductSiteBindingConverter");

var ProductSiteBindingConverterImpl_1 = require("./conversions/ProductSiteBindingConverterImpl");

var ProductSiteNewConverter_1 = require("./conversions/ProductSiteNewConverter");

var ProductSiteNewConverterImpl_1 = require("./conversions/ProductSiteNewConverterImpl");

var ProductVATByProductConverter_1 = require("./conversions/ProductVATByProductConverter");

var ProductVATByProductConverterImpl_1 = require("./conversions/ProductVATByProductConverterImpl");

var ProductVATByProductDataConverter_1 = require("./conversions/ProductVATByProductDataConverter");

var ProductVATByProductDataConverterImpl_1 = require("./conversions/ProductVATByProductDataConverterImpl");

var ProductVATConverter_1 = require("./conversions/ProductVATConverter");

var ProductVATConverterImpl_1 = require("./conversions/ProductVATConverterImpl");

var RegularProductPriceConverter_1 = require("./conversions/RegularProductPriceConverter");

var RegularProductPriceConverterImpl_1 = require("./conversions/RegularProductPriceConverterImpl");

var RoundedProductPriceConverter_1 = require("./conversions/RoundedProductPriceConverter");

var RoundedProductPriceConverterImpl_1 = require("./conversions/RoundedProductPriceConverterImpl");

var SimilarProductConverter_1 = require("./conversions/SimilarProductConverter");

var SimilarProductConverterImpl_1 = require("./conversions/SimilarProductConverterImpl");

var UserProductCategoryConverter_1 = require("./conversions/UserProductCategoryConverter");

var UserProductCategoryConverterImpl_1 = require("./conversions/UserProductCategoryConverterImpl");

var ZonePricesConverter_1 = require("./conversions/ZonePricesConverter");

var ZonePricesConverterImpl_1 = require("./conversions/ZonePricesConverterImpl");
/**
 * Configures product app module.
 * @author JMe
 * @author RV
 * @author Radek Beran
 * @author Tomáš Leity
 */


var ProductAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(ProductAppModule, _AppModule_1$AppModul);

  function ProductAppModule() {
    var _this;

    _classCallCheck(this, ProductAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'productAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ProductAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(ProductPriceConverter_1.ProductPriceConverter).to(ProductPriceConverterImpl_1.ProductPriceConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PlacementTypesConverter_1.PlacementTypesConverter).to(PlacementTypesConverterImpl_1.PlacementTypesConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(RoundedProductPriceConverter_1.RoundedProductPriceConverter).to(RoundedProductPriceConverterImpl_1.RoundedProductPriceConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(RegularProductPriceConverter_1.RegularProductPriceConverter).to(RegularProductPriceConverterImpl_1.RegularProductPriceConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceChangeIndexConverter_1.PriceChangeIndexConverter).to(PriceChangeIndexConverterImpl_1.PriceChangeIndexConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductEANConverter_1.ProductEANConverter).to(ProductEANConverterImpl_1.ProductEANConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductConverter_1.ProductConverter).to(ProductConverterImpl_1.ProductConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductCategoryConverter_1.ProductCategoryConverter).to(ProductCategoryConverterImpl_1.ProductCategoryConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductCategoryChangeConverter_1.ProductCategoryChangeConverter).to(ProductCategoryChangeConverterImpl_1.ProductCategoryChangeConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductCategoryChangeProcessConverter_1.ProductCategoryChangeProcessConverter).to(ProductCategoryChangeProcessConverterImpl_1.ProductCategoryChangeProcessConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductSensitivityConverter_1.ProductSensitivityConverter).to(ProductSensitivityConverterImpl_1.ProductSensitivityConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductSensitivityExportQueueRecordConverter_1.ProductSensitivityExportQueueRecordConverter).to(ProductSensitivityExportQueueRecordConverterImpl_1.ProductSensitivityExportQueueRecordConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(CompetitorProductConverter_1.CompetitorProductConverter).to(CompetitorProductConverterImpl_1.CompetitorProductConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductInfoFilterConverter_1.ProductInfoFilterConverter).to(ProductInfoFilterConverterImpl_1.ProductInfoFilterConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(CompetitorProductFilterConverter_1.CompetitorProductFilterConverter).to(CompetitorProductFilterConverterImpl_1.CompetitorProductFilterConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(CompetitorProductBindingConverter_1.CompetitorProductBindingConverter).to(CompetitorProductBindingConverterImpl_1.CompetitorProductBindingConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(UserProductCategoryConverter_1.UserProductCategoryConverter).to(UserProductCategoryConverterImpl_1.UserProductCategoryConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductSiteBindingConverter_1.ProductSiteBindingConverter).to(ProductSiteBindingConverterImpl_1.ProductSiteBindingConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductPurchasePriceConverter_1.ProductPurchasePriceConverter).to(ProductPurchasePriceConverterImpl_1.ProductPurchasePriceConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductVATConverter_1.ProductVATConverter).to(ProductVATConverterImpl_1.ProductVATConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductVATByProductConverter_1.ProductVATByProductConverter).to(ProductVATByProductConverterImpl_1.ProductVATByProductConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductVATByProductDataConverter_1.ProductVATByProductDataConverter).to(ProductVATByProductDataConverterImpl_1.ProductVATByProductDataConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductPlacementConverter_1.ProductPlacementConverter).to(ProductPlacementConverterImpl_1.ProductPlacementConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductSiteNewConverter_1.ProductSiteNewConverter).to(ProductSiteNewConverterImpl_1.ProductSiteNewConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SimilarProductConverter_1.SimilarProductConverter).to(SimilarProductConverterImpl_1.SimilarProductConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceArchitectureExportDTOConverter_1.PriceArchitectureExportDTOConverter).to(PriceArchitectureExportDTOConverterImpl_1.PriceArchitectureExportDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductInfoConverter_1.ProductInfoConverter).to(ProductInfoConverterImpl_1.ProductInfoConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductNameAndCategoriesConverter_1.ProductNameAndCategoriesConverter).to(ProductNameAndCategoriesConverterImpl_1.ProductNameAndCategoriesConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(FindWindowProductsDTOConverter_1.FindWindowProductsDTOConverter).to(FindWindowProductsDTOConverterImpl_1.FindWindowProductsDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceWithValidityConverter_1.PriceWithValidityConverter).to(PriceWithValidityConverterImpl_1.PriceWithValidityConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceWithVatConverter_1.PriceWithVatConverter).to(PriceWithVatConverterImpl_1.PriceWithVatConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ZonePricesConverter_1.ZonePricesConverter).to(ZonePricesConverterImpl_1.ZonePricesConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return ProductAppModule;
}(AppModule_1.AppModule);

exports.ProductAppModule = ProductAppModule;